<template>
    <div class="news">
        <NavBar :white="true" />
        <NewsDetailContent />
    </div>
</template>

<script>
    import NavBar from "../../components/NavBar";
    import NewsDetailContent from "../../components/news/NewsDetailContent";

    export default {
        name: 'GlobalNews',
        components: {
            NavBar,
            NewsDetailContent
        }
    }
</script>

<style lang="scss">
    .news {
        padding-top: 160px;
    }
</style>